import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../../utils/formatters';
import { conditionKey } from '../../../data/categories';

export default function ProductDetails({ postContent, dateLabel, name }) {
  const { t } = useTranslation();
  return (
    <div className="productDetails">
      {(postContent.adType === 'for_rent' ||
        postContent.adType === 'wanted' ||
        postContent.adType === 'exchange' ||
        postContent.adType === 'free') && (
        <span className="viewAdTypeBadge">
          {postContent.adType === 'for_rent'
            ? t('adTypes.forRent')
            : postContent.adType === 'wanted'
              ? t('adTypes.wanted')
              : postContent.adType === 'exchange'
                ? t('adTypes.exchange')
                : t('adTypes.free')}
        </span>
      )}
      <p className="viewPrice">
        {postContent.originalPrice != null &&
          postContent.originalPrice > postContent.price && (
            <span className="viewOriginalPrice">
              {formatPrice(postContent.originalPrice, postContent)}
            </span>
          )}
        {formatPrice(postContent.price, postContent)}
        {(postContent.negotiable || postContent.priceType === 'negotiable') && (
          <span className="viewNegotiable">{t('priceTypes.negotiable')}</span>
        )}
        {postContent.priceType === 'free' && (
          <span className="viewNegotiable">{t('priceTypes.free')}</span>
        )}
        {postContent.priceType === 'contact' && (
          <span className="viewNegotiable">{t('priceTypes.contact')}</span>
        )}
      </p>
      <h1 className="viewTitle">{name != null ? name : postContent.name}</h1>
      <p className="viewMeta">
        {postContent.adType === 'for_sale' && `${t('adTypes.forSale')} · `}
        {postContent.category}
        {postContent.subcategory ? ` › ${postContent.subcategory}` : ''}
        {postContent.condition && ` · ${t(`conditions.${conditionKey(postContent.condition)}`)}`}
        {postContent.listedBy && ` · ${postContent.listedBy}`}
      </p>
      {Array.isArray(postContent.tags) && postContent.tags.length > 0 && (
        <div className="viewTags">
          {postContent.tags.map((tag) => (
            <span key={tag} className="viewTag">
              {tag}
            </span>
          ))}
        </div>
      )}
      {postContent.extra && Object.keys(postContent.extra).length > 0 && (
        <div className="viewExtraDetails">
          {Object.entries(postContent.extra).map(([key, value]) => {
            if (!value && value !== 0) return null;
            const label = key
              .replace(/([A-Z])/g, ' $1')
              .replace(/^./, (s) => s.toUpperCase())
              .replace(/Sq ft/g, '(sq ft)')
              .replace(/Km/g, 'KM');
            return (
              <div key={key} className="viewExtraItem">
                <span className="viewExtraLabel">{label}</span>
                <span className="viewExtraValue">{String(value)}</span>
              </div>
            );
          })}
        </div>
      )}
      {(postContent.location?.city || postContent.location?.state) && (
        <p className="viewLocation">
          <span className="viewLocationIcon">📍</span>
          {[postContent.location.city, postContent.location.state]
            .filter(Boolean)
            .join(', ')}
        </p>
      )}
      {postContent.delivery?.available && (
        <p className="viewDelivery">
          <span className="viewDeliveryIcon">🚚</span>
          {t('createAd.deliveryAvailable')}
          {postContent.delivery.shippingCost > 0 &&
            ` · ${formatPrice(postContent.delivery.shippingCost)} ${t('createAd.shippingCost')}`}
          {postContent.delivery.estimatedDays &&
            ` · ${postContent.delivery.estimatedDays}`}
        </p>
      )}
      {postContent.warranty?.available && (
        <p className="viewWarranty">
          <span className="viewWarrantyIcon">🛡️</span>
          {t('createAd.warrantyType')}: {postContent.warranty.type || t('common.yes')}
          {postContent.warranty.description &&
            ` — ${postContent.warranty.description}`}
        </p>
      )}
      {postContent.returnPolicy &&
        postContent.returnPolicy !== 'no_returns' && (
          <p className="viewReturnPolicy">
            {t('createAd.returnPolicy')}: {postContent.returnPolicy.replace('_', ' ')}
          </p>
        )}
      {Array.isArray(postContent.paymentMethods) &&
        postContent.paymentMethods.length > 0 && (
          <p className="viewPaymentMethods">
            {t('createAd.paymentMethodsAccepted')}: {postContent.paymentMethods.join(', ')}
          </p>
        )}
      {postContent.stats &&
        (postContent.stats.views > 0 ||
          postContent.stats.favorites > 0 ||
          postContent.stats.shares > 0) && (
          <p className="viewStats">
            {postContent.stats.views > 0 && (
              <span>{t('productView.views', { count: postContent.stats.views })}</span>
            )}
            {postContent.stats.favorites > 0 && (
              <span>{t('productView.favorites', { count: postContent.stats.favorites })}</span>
            )}
            {postContent.stats.shares > 0 && (
              <span>{t('dashboard.adShares', { count: postContent.stats.shares })}</span>
            )}
          </p>
        )}
      {dateLabel && <p className="viewDate">{t('productView.postedOn')} {dateLabel}</p>}
      {postContent.status === 'sold' && (
        <span className="viewSoldBadge">{t('productView.sold')}</span>
      )}
    </div>
  );
}
